import * as React from 'react'
import {FC} from 'react'
import {observer} from 'mobx-react'
import cn from 'classnames'
import {useStores} from '../../../../../lib/MobXProvider'
import {WidgetApi} from '../../../../../lib/WidgetApi'
import {PaymentForm} from '../../../../../lib/forms/PaymentForm'
import {SubscriptionRenewForm} from '../../../../../lib/forms/SubscriptionRenewForm'
import {DynamicSlot} from '../../../../dynamic/DynamicSlot'
import {DynamicSlotName} from '../../../../../lib/DynamicSlotName'
import {InputRadioWrapper} from '../../../../wrappers/InputCheckableWrapper'
import {InfoToggle} from '../../../../ui/InfoToggle'
import {PaymentMethodInfo} from '../PaymentMethodInfo'

///////////////////////////////////////////////////////////////////////////////

export type PaymentSlipFormProps = {
  form: PaymentForm | SubscriptionRenewForm
}

///////////////////////////////////////////////////////////////////////////////

export const PaymentSlipForm: FC<PaymentSlipFormProps> = observer((props) => {
  const {api} = useStores<{api: WidgetApi}>()
  const {form} = props
  const formData = form.data
  const paymentMethod = form.getPaymentMethod()
  const paymentSlipDeliveryTypes = form.getPossiblePaymentSlipDeliveryTypes()

  if (paymentSlipDeliveryTypes.length === 1) {
    return <PaymentMethodInfo paymentMethod={paymentMethod} />
  }

  const paymentMethodInfoTextHTML = api.trans(
    `payment_method_info.${paymentMethod}.text_html`,
    {defaultValue: null},
  )
  const infoToggleTitle = api.trans(`info_toggle.${paymentMethod}.title`, {
    defaultValue: null,
  })
  const infoToggleTextHTML = api.trans(
    `info_toggle.${paymentMethod}.text_html`,
    {defaultValue: null},
  )

  return (
    <div className={cn('payment-method-form', paymentMethod)}>
      <DynamicSlot name={DynamicSlotName.PAYMENT_SLIP_FORM_START} form={form} />

      <div className="main">
        <div className="list-items">
          {paymentSlipDeliveryTypes.map((deliveryType, key) => {
            let isChecked =
              deliveryType === formData.stored_payment_slip_delivery_type
            let setDeliveryType = () =>
              (formData.stored_payment_slip_delivery_type = deliveryType)

            return (
              <label
                key={key}
                className={cn('label-radio-block', 'list-item', {
                  selected: isChecked,
                })}
              >
                <div className="label-radio-block-inner">
                  <InputRadioWrapper>
                    <input
                      type="radio"
                      className="input-radio"
                      name="stored_payment_slip_delivery_type"
                      value={deliveryType}
                      onChange={setDeliveryType}
                      checked={isChecked}
                    />
                  </InputRadioWrapper>
                  <span className="title">
                    {api.trans(`payment_slip_delivery_types.${deliveryType}`)}
                  </span>
                </div>
              </label>
            )
          })}
        </div>

        {paymentMethodInfoTextHTML && (
          <div
            className="text"
            aria-live="polite"
            dangerouslySetInnerHTML={{__html: paymentMethodInfoTextHTML}}
          />
        )}
      </div>

      <InfoToggle
        idKey={'info-toggle-' + paymentMethod}
        className={cn('info-toggle-pm', 'info-toggle-' + paymentMethod)}
        title={infoToggleTitle}
        textHTML={infoToggleTextHTML}
      />

      <DynamicSlot name={DynamicSlotName.PAYMENT_SLIP_FORM_END} form={form} />
    </div>
  )
})
